<div class="modal-header">
  <h5 class="modal-title">Archive Case</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">

  <div class="mb-3">
    <label class="form-label fw-semibold">Reason</label>
    <select class="form-select" [(ngModel)]="selectedReason">
      <option *ngFor="let reason of reasons" [ngValue]="reason.id">{{reason.reason}}</option>
    </select>
  </div>

  <div class="mb-3" *ngIf="selectedReason == 2">
    <label class="form-label fw-semibold">Details</label>
    <textarea class="form-control" [(ngModel)]="archiveReasonOther" maxlength="500" rows="3"></textarea>
  </div>

</div>

<div class="modal-footer">
  <button *ngIf="!isLoading" type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>

  <button *ngIf="!isLoading" type="button" class="btn btn-success"
    [disabled]="selectedReason == null || (selectedReason == 2 && archiveReasonOther.length == 0)"
    (click)="save()">Save</button>

  <button *ngIf="isLoading" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Saving...
  </button>
</div>